document.addEventListener('click', (e) => {
	const { target } = e;
	const link = target.closest('a');
	if (link && link.href && link.href.indexOf('.pdf') !== -1) {
		e.preventDefault();
		window.open(link.href, '_blank');
	}
});
